import { IFilterReference, SortSpecifies } from "./interfaces";
import * as MendixApi from "./mendixApi";

/**
 * Retrieve entity by a contraints. A contraint is one of two following format
 *  - which has [%CurrentObject%]: [entity1_entity2/entity2/entity2_entity3='[%CurrentObject%]']
 *  - which does not have [%CurrentObject%]: [entity1_entity2/entity2/entity2_entity3/entity3]
 */
export function retrieveEntityByConstraint(
    entityName: string, constraintString: string, referredObjectId: string, otherConstrains: string[] | undefined,
    filterAttribute: string[] = [], filterReference: IFilterReference, sortSpec?: SortSpecifies, limit?: number
): Promise<any> {
    if (entityName && constraintString && referredObjectId) {
        const xPath: string = generateXpathForConstraint(
            entityName, constraintString, referredObjectId, otherConstrains
        );
        return MendixApi.retrieveObjectsByXpath(xPath, filterAttribute, filterReference, sortSpec, limit);
    } else {
        return new Promise(resolve => { resolve({ error: "The input was missing a required parameter" }); });
    }
}
/**
 * Retrieve entity by association
 *
 */
export function retrieveEntityByAssociation(
    retrievingEntityName: string, association: string, referredObjIds: string[],
    filterAttribute: string[] = [], filterReference: IFilterReference,
    sortSpec?: SortSpecifies, limit?: number
): Promise<any> {
    if (retrievingEntityName && association && referredObjIds.length > 0) {
        const xPath = generateXpathForAssociation(retrievingEntityName, association, referredObjIds);
        return MendixApi.retrieveObjectsByXpath(xPath, filterAttribute, filterReference, sortSpec, limit);
    } else {
        return new Promise(resolve => { resolve({ error: "The input was missing a required parameter" }); });
    }
}
function generateXpathForConstraint(
    entityName: string, constraintString: string,
    referredObjectId: string, otherConstrains?: string[]
) {
    let xPath = "";
    if (constraintString.indexOf("'[%CurrentObject%]'") >= 0) {
        while (constraintString.indexOf("'[%CurrentObject%]'") >= 0) {
            constraintString = constraintString.split("'[%CurrentObject%]'").join(referredObjectId);
        }
        xPath = "//" + entityName + constraintString;
    } else {
        const lastSlash = constraintString.lastIndexOf("/");
        xPath = "//" + entityName + constraintString.substring(0, lastSlash) + "=" + referredObjectId + "]";
    }
    if (otherConstrains) {
        let extraContrains = "";
        otherConstrains.forEach(otherConstrain => extraContrains += otherConstrain);
        const lastIndexOf = xPath.lastIndexOf("]");
        xPath = xPath.substring(0, lastIndexOf) + extraContrains + "]";
    }
    return xPath;
}
function generateXpathForAssociation(entityName: string, association: string, referredObjIds: string[]) {
    if (association.includes("[")) { association = association.substring(1, association.length - 1); }
    const lastSlash = association.lastIndexOf("/");
    association = association.substring(0, lastSlash);
    let xPath = `//${entityName}[`;
    referredObjIds.forEach((referredObjId, index) => {
        xPath += index === 0 ? `${association}=${referredObjId}` : ` or ${association}=${referredObjId}`;
    });
    xPath += "]";
    return xPath;
}
